import React from 'react';
import { Badge, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faDollarSign } from '@fortawesome/free-solid-svg-icons';

/**
 * BatchScopePanel - Displays selection summary with batch scope estimates
 * Shows selected count, filtered/total context, and estimated time/cost
 * Only renders when products are selected (selectedCount > 0)
 */
export const BatchScopePanel = ({
    selectedCount = 0,
    totalProducts = 0,
    filteredCount = 0,
    onClearSelection
}) => {
    // Don't render if nothing selected
    if (selectedCount === 0) return null;

    // Calculate batch scope estimates
    // ~2 sec per product for enrichment processing
    const estimatedTimeMinutes = Math.ceil(selectedCount * 2 / 60);
    // Average enrichment cost per product
    const estimatedCost = (selectedCount * 0.015).toFixed(2);

    return (
        <div className="batch-scope-panel">
            <div className="scope-summary">
                <strong>{selectedCount.toLocaleString()}</strong> {selectedCount === 1 ? 'product' : 'products'} selected
                {filteredCount > 0 && filteredCount < totalProducts && (
                    <span className="text-muted ms-2">
                        from {filteredCount.toLocaleString()} filtered
                        (of {totalProducts.toLocaleString()} total)
                    </span>
                )}
            </div>
            <div className="scope-estimates">
                <Badge bg="secondary" className="me-2">
                    <FontAwesomeIcon icon={faClock} className="me-1" />
                    ~{estimatedTimeMinutes} min
                </Badge>
                <Badge bg="info">
                    <FontAwesomeIcon icon={faDollarSign} className="me-1" />
                    ~${estimatedCost}
                </Badge>
            </div>
            <Button
                variant="link"
                size="sm"
                onClick={onClearSelection}
                className="clear-selection-btn"
            >
                Clear selection
            </Button>
        </div>
    );
};

export default BatchScopePanel;
